var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3225_16835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3225_16835)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 110,
    x2: 89,
    y2: 118,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 95,
    x2: 56,
    y2: 103,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 87,
    x2: 96,
    y2: 95,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 101,
    x2: 71,
    y2: 109,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 113,
    x2: 44,
    y2: 121,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 110,
    x2: 110,
    y2: 118,
    stroke: "#708A97",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.926 74.1119C73.2248 74.1119 72.5442 74.1725 71.8957 74.2859C70.7336 73.1541 68.7952 72.4128 66.5993 72.4128C65.8859 72.4128 65.201 72.4921 64.5596 72.6364C63.4784 69.4102 59.2043 67 54.0931 67C48.1653 67 43.3599 70.2405 43.3599 74.2379C43.3599 74.3203 43.3653 74.402 43.369 74.4834C42.6146 74.3239 41.8121 74.2379 40.9797 74.2379C36.5728 74.2379 33 76.6467 33 79.6192C33 82.591 36.5729 85 40.9797 85H64.872H69.3061H73.9263C78.3852 85 82 82.5625 82 79.556C81.9997 76.5492 78.3849 74.1119 73.926 74.1119Z",
    fill: "#324D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.926 59.1119C109.225 59.1119 108.544 59.1725 107.896 59.2859C106.734 58.1541 104.795 57.4128 102.599 57.4128C101.886 57.4128 101.201 57.4921 100.56 57.6364C99.4784 54.4102 95.2043 52 90.0931 52C84.1653 52 79.3599 55.2405 79.3599 59.2379C79.3599 59.3203 79.3653 59.402 79.369 59.4834C78.6146 59.3239 77.8121 59.2379 76.9797 59.2379C72.5728 59.2379 69 61.6467 69 64.6192C69 67.591 72.5729 70 76.9797 70H100.872H105.306H109.926C114.385 70 118 67.5625 118 64.556C118 61.5492 114.385 59.1119 109.926 59.1119Z",
    fill: "#324D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.926 44.1119C68.2248 44.1119 67.5442 44.1725 66.8957 44.2859C65.7336 43.1541 63.7952 42.4128 61.5993 42.4128C60.8859 42.4128 60.201 42.4921 59.5596 42.6364C58.4784 39.4102 54.2043 37 49.0931 37C43.1653 37 38.3599 40.2405 38.3599 44.2379C38.3599 44.3203 38.3653 44.402 38.369 44.4834C37.6146 44.3239 36.8121 44.2379 35.9797 44.2379C31.5728 44.2379 28 46.6467 28 49.6192C28 52.591 31.5729 55 35.9797 55H59.872H64.3061H68.9263C73.3852 55 77 52.5625 77 49.556C76.9997 46.5492 73.3849 44.1119 68.926 44.1119Z",
    fill: "#324D5A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.5d85ec8595c772b95afe20100575fe93.svg";
export { ForwardRef as ReactComponent };